window.monster_protection_event_listner = "click";
window.monster_protection_selectors = ['[name="checkout"]']
window.monster_protection_checkout_selectors = ['[name="checkout"]']
window.monster_protection_dynamic_selectors = ["shopify-section-cart-drawer"]
window.monster_protection_checkout_selectors_cart_page = ['[data-cart-checkout-button]']

async function goToCheckout() {
  const protect_active = !!document.querySelector('script[src*="/protect_renderer."]');
  // console.log(protect_active)
  if(window.monster_protection_selected && protect_active && !window.monster_protection_added) {
    // console.log("ADD")
    const response = await fetch(window.location.origin + "/cart/add.js", {
      headers: {
        "content-type": "application/json;"
      },
      body: JSON.stringify({ items: [
        {
          quantity: 1,
          id: window.monster_protection_variant+""
        }
      ] }),
      method: "POST",
    }).then(() => {
      window.monster_protection_added = true;
    }).catch((error) => {
      window.monster_protection_added = false;
      // console.log("couldn't add shipping protection");
      // console.log(error);
    });
    // console.log(response);
  };
  window.location.href = "/checkout";
}

function copyAndHideCheckoutButtons(cart) {
  let checkout_buttons = document.querySelectorAll(monster_protection_checkout_selectors_cart_page.join(","));
  checkout_buttons.forEach(checkout_button => {
    // Check if the button already has a clone
    if (!checkout_button.dataset.cloned) {
      // Clone the button
      let clone = checkout_button.cloneNode(true);
      clone.removeAttribute("name");
      clone.removeAttribute("href");
      clone.setAttribute("type", "button");
      clone.setAttribute("onclick", "goToCheckout()");
      checkout_button.after(clone);
      // Hide the original button
      checkout_button.style.display = 'none';
      // Mark the button as cloned
      checkout_button.dataset.cloned = 'true';
    }
  });
}

function start_observing_monster(cart) {
  let mu_cart_observer = new MutationObserver(() => {
    mu_cart_observer.disconnect();
    copyAndHideCheckoutButtons(cart);
    mu_cart_observer.observe(cart, { childList: true, subtree: true });
  });
  mu_cart_observer.observe(cart, { childList: true, subtree: true });
}

let mu_body_observer = new MutationObserver(() => {
  let carts = document.querySelectorAll(monster_protection_dynamic_selectors?.map((selector) => ("#"+selector)).join(","));
  if (carts.length) {
    mu_body_observer.disconnect();
    var cart_checkOut;
    carts.forEach(cart => {
      cart_checkOut = cart;
    });
    start_observing_monster(cart_checkOut);
    
  }
})
mu_body_observer.observe(document.querySelector('body'), { childList: true, subtree: true });

// Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie value
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


const cartImages = document.querySelectorAll('.underwear-upsell-container .custom.carouselOfImages');

function initializeSlider() {
    cartImages.forEach(carousel => {
        // Initialize Flickity
        new Flickity(carousel, {
            cellAlign: 'left',
            contain: false,
            friction: 0.2,
            initialIndex: 0,
            pageDots: true,
            lazyLoad: false,
            wrapAround: true,
            cellSelector: '.collection-product__anchor',
            prevNextButtons: false,
        });
    });
}

function destroySlider() {
    cartImages.forEach(carousel => {
        // Get the Flickity instance attached to this element
        const flickityInstance = Flickity.data(carousel);

        // Destroy the Flickity instance if it exists
        if (flickityInstance) {
            flickityInstance.destroy();
        }
    });
}

// Related Popup on product page only

function show_related_popup_product_click(event) {
    var cart_drawer_popup = document.querySelectorAll('[cart_drawer_popup_related]');
    
    // Check if cart_drawer_popup exists in the DOM
    if (cart_drawer_popup.length > 0) {
        cart_drawer_popup.forEach(item => {
            if (item.classList.contains('hidden')) {
                item.classList.remove('hidden');
                
                // Apply slider
                var custom_image_slider_cart = document.querySelectorAll('[custom_slider_cart_drawer_related_upsell]');
                if (custom_image_slider_cart.length > 0) {
                    custom_image_slider_cart.forEach(carousel => {
                        var flkty_img_cart = new Flickity(carousel, {
                            cellAlign: 'left',
                            prevNextButtons: true,
                            pageDots: true,
                            wrapAround: false,
                            contain: true
                        });
                    });
                }
            }
        });
    }
}

function close_related_popup(event) {
  var cart_drawer_popup = document.querySelectorAll('[cart_drawer_popup_related]');
  cart_drawer_popup.forEach(item => {
      item.classList.add('hidden');
      document.querySelector('.overlay_close_btn').style.display = 'none';
  });
}

// Delay and reapply the slider

function show_poup_cart_click(event){
  if(!getCookie('cartDrawerPopupShown')){
    var cart_drawer_popup = document.querySelectorAll('[cart_drawer_popup]');
    cart_drawer_popup.forEach(item => {
      if (item.classList.contains('hidden')) {
        item.classList.remove('hidden');
        // apply slider
        var custom_image_slider_cart = document.querySelectorAll('[custom_slider_cart_drawer]');
        if(custom_image_slider_cart){
          destroySlider();
        custom_image_slider_cart.forEach(carousel => {
           flkty_img_cart = new Flickity(carousel, {
              cellAlign: 'left',
              prevNextButtons: true,
              pageDots: true,
              wrapAround: false,
             contain:true
            });
          });
        }
        setTimeout(() => {
            destroySlider(); // Destroy existing slider
            initializeSlider(); // Reinitialize the slider
        }, 3000);
      }
      if (event.classList.contains('cart_button')) {
         document.querySelector('.close_button_popup').classList.add('cart_button_close');
         document.querySelector('.overlay_close_btn').classList.add('cart_button_close');
      }else if (event.classList.contains('checkout_button')) {
        document.querySelector('.close_button_popup').classList.add('checkout_button_close');
        document.querySelector('.overlay_close_btn').classList.add('checkout_button_close');
      }
    });
  }else{
    if (event.classList.contains('cart_button')) {
       window.location.href='/cart'
    }else if (event.classList.contains('checkout_button')) {
      goToCheckout();
    }
  }
}

function close_popup(event) {
    var cart_drawer_popup = document.querySelectorAll('[cart_drawer_popup]');
    cart_drawer_popup.forEach(item => {
        item.classList.add('hidden');
        document.querySelector('.overlay_close_btn').style.display = 'none';
        setCookie('cartDrawerPopupShown', 'true', 7);
       setTimeout(() => {
        if (event.classList.contains('cart_button_close')) {
           window.location.href='/cart'
        }else if (event.classList.contains('checkout_button_close')) {
          goToCheckout();
        }
       },1000);
    });
  }


setTimeout(() => {
    let elements = document.querySelectorAll('.cart-drawer-form .money');

    elements.forEach(element => {
        let newValue = element.innerHTML.replace(/(\.\d{2})$/, (match, p1) => {
            return p1 === ".00" ? "" : p1;
        });
        let currency = element.getAttribute('data-currency');
        element.innerHTML = newValue + " " + currency;

        // Update data attributes to match the new value
        element.setAttribute('data-currency-original', newValue + " " + currency);
        element.setAttribute('data-currency-aud', newValue + " " + currency);

        // console.log(`Updated money element: ${element.innerHTML}`, element);
    });
  }, 500);

// custom ATC start

function ATC_cart() {
  // const addToCartButtons = document.querySelectorAll('[custom_add_cart]');
  // addToCartButtons.forEach(function(ite) {
  //   ite.addEventListener('click', function() {
  //       const currentVariant = this.closest('.product-stl').querySelector('.product-stl__select').value;
  //       DisplayAddingAnimationStl('block', 'Adding...', this);
  //       CartJS.addItem(currentVariant, 1, {}, {
  //           success: function(data, textStatus, jqXHR) {
  //               setTimeout(function() {
  //                   // Update cart
  //                   updateCartDrawer();
  //                   updateCartItemCounts(CartJS.cart.item_count);
                    
  //                   // Open cart drawer
  //                   openCartDrawer();
  
  //                   DisplayAddingAnimationStl('none', 'Add to bag', this);
  //               }, 1000);
  //           },
  //           // Define an error callback to display an error message.
  //           error: function(jqXHR, textStatus, errorThrown) {
  //               console.error('There was a problem adding to the cart!');
  //           }
  //       });
  //       setCookie('cartDrawerPopupShown', 'true', 7);
  //   });
  // });
}
function DisplayAddingAnimationStl(action, text , button) {
  const addToCartButton = button;
  if (addToCartButton) {
    addToCartButton.querySelector('span[data-add-to-cart-text]').textContent = text;
    const spinner = button.querySelector('.spinner');
    if (spinner) {
      spinner.style.display = action;
    }
  }
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  
  addCartDrawerListeners();
}

function openCartDrawer() {
  show_related_popup_product_click();
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}
function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}
function updateCartItemCounts(count) {
  document.querySelectorAll(".cart_count").forEach((el) => {
    el.textContent = count;
  });
}
function addCartDrawerListeners() {
  
  //custom ATC

  const addToCartButtons = document.querySelectorAll('[custom_add_cart]');
  addToCartButtons.forEach(function(ite) {
    ite.addEventListener('click', function() {
        const currentVariant = this.closest('.product-stl').querySelector('.product-stl__select').value;
        DisplayAddingAnimationStl('block', 'Adding...', this);
        CartJS.addItem(currentVariant, 1, {}, {
            success: function(data, textStatus, jqXHR) {
                setTimeout(function() {
                    // Update cart
                    updateCartDrawer();
                    updateCartItemCounts(CartJS.cart.item_count);
                  
                    DisplayAddingAnimationStl('none', 'Add to bag', this);
                    
                    // Open cart drawer
                    openCartDrawer();
  
                }, 1000);
            },
            // Define an error callback to display an error message.
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('There was a problem adding to the cart!');
            }
        });
        setCookie('cartDrawerPopupShown', 'true', 7);
    });
  });


  
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement.parentElement;
        const key = button.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        // const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
        const newQuantity = 0;
        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

if(document.querySelector(".cart-drawer-box")){
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });
}

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

ATC_cart();
addCartDrawerListeners();


// custom ATC end